export const COLORS = {
  softBlack70: '#2e2b2eb3',
  volt: '#EDDF65',
  softBlack30: '#2e2b2e4d',
  softBlack: 'rgba(46, 43, 46, 1)',
  lightGray: '#F2F2F1',
  darkGray: '#2E2B2E4D',
  white: '#FCFCFA'
}
